export const getProgressStateText = (state) => {

    console.info(state)

    switch (state) {
        case 'SCHEDULE':
            return 'Programado';
        case 'IN_PROGRESS':
            return 'En progreso';
        case 'REVIEW':
            return 'En revisión';
        case 'COMPLETE_NOT_PAY':
            return 'Completado - Pendiente de pago';
        case 'COMPLETE_AND_PAY':
            return 'Completado - Pagado';
        default:
            return 'Estado desconocido';
    }
};